import './pagination-footer.css';

type PaginationFooterProps = {
  disabled?: boolean;
  currentPage: number;
  totalPage?: number;
  pageSize: number;
  canNextPage: boolean;
  canPreviousPage: boolean;
  handleNextPage: () => void;
  handlePreviousPage: () => void;
  setPageSize: (next: number) => void;
  showTotalPage?: boolean;
};

export const PaginationFooter = ({
  currentPage,
  totalPage,
  pageSize,
  canNextPage,
  canPreviousPage,
  handleNextPage,
  handlePreviousPage,
  setPageSize,
  showTotalPage = true,
  disabled = false,
}: PaginationFooterProps) => {
  const hasTotalPage = typeof totalPage === 'number';

  return (
    <>
      <div className="pagination-footer-container">
        <div className="pagination-footer-page-swtich">
          <button
            className="pagination-footer-button"
            type="button"
            disabled={!canPreviousPage || disabled}
            onClick={handlePreviousPage}
          >
            <i className="fa-solid fa-caret-left fa-md" />
          </button>
          Page {currentPage}{' '}
          {showTotalPage && hasTotalPage
            ? `of ${totalPage > 0 ? totalPage : 1}`
            : ''}
          <button
            className="pagination-footer-button"
            type="button"
            disabled={!canNextPage || disabled}
            onClick={handleNextPage}
          >
            <i className="fa-solid fa-caret-right fa-md" />
          </button>
        </div>
        <label className="pagination-footer-page-size">
          Showing
          <select
            className="custom-select"
            id="inputGroupSelect01"
            value={pageSize}
            onChange={(e) => {
              const newValue = Number(e.target.value);
              setPageSize(newValue);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </label>
      </div>
    </>
  );
};
